import { proxy } from 'valtio'
import { jwtDecode } from 'jwt-decode'
import { derive, devtools, subscribeKey } from 'valtio/utils'
import { resetProxy } from '../utils/proxyUtils'
import { retrieveAuthToken, setAuthToken } from '../utils/authUtils'
import { type GlobalSiteThemeType } from '../types/GlobalSiteThemeType'
import wastePayTheme from '../themes/wastePayTheme'
import { type GlobalSiteDomainEnum } from '../types/GlobalSiteDomainEnum'
import { defaultDomainEnum } from '../utils/domainUtils'
import domains from '../types/domains'

interface ProxyGlobalAuth {
  authToken: string | null
  siteTheme: GlobalSiteThemeType
  siteDomainEnum: GlobalSiteDomainEnum
}

const initialValues = {
  authToken: retrieveAuthToken(),
  siteDomainEnum: defaultDomainEnum,
  siteTheme: wastePayTheme
}

const baseProxy = proxy<ProxyGlobalAuth>(initialValues)
export const proxyGlobalAuth = derive({
  siteDomain: get => {
    const { siteDomainEnum } = get(baseProxy)
    return domains[siteDomainEnum]
  },
  userId: get => {
    const { authToken } = get(baseProxy)
    if (!authToken) { return null }
    const decoded = jwtDecode<{ userId: number }>(authToken)
    return decoded.userId.toString()
  }
}, { proxy: baseProxy })
devtools(proxyGlobalAuth, { name: 'proxyGlobalAuth' })
subscribeKey(proxyGlobalAuth, 'authToken', (authToken) => {
  setAuthToken(authToken ?? '')
})

export function resetProxyGlobalAuth (): void {
  resetProxy(initialValues, proxyGlobalAuth)
}
